import PropTypes from "prop-types";
import React, { useState, useMemo } from "react";
import { Container, Card, CardBody } from "reactstrap";

// PrimeReact
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import ActionEditLink from "components/buttons/btnDetail";
import ClientMenu from "./detail-menu";

const ClientsDetail = props => {
  // Meta title
  document.title = "Admin | Clients";

  // -------------------- STATE --------------------
  const [globalFilter, setGlobalFilter] = useState("");
  const [clientType, setClientType] = useState(null);
  const [planType, setPlanType] = useState(null);
  const [startDate, setStartDate] = useState(null);

  // -------------------- SAMPLE DATA --------------------
  const clients = [
    {
      id: 1,
      buisnessName: "ABC Realty",
      address: "Toronto",
      contactName: "John Smith",
      mobilePhone: "+1 (555) 123-4567",
      phone: "+1 (555) 987-6543 - ext. 101",
    
    },
    {
      id: 2,
      buisnessName: "Prime Homes",
      address: "Mississauga",
      contactName: "Sarah Lee",
      mobilePhone: "+1 (555) 123-4567",
      phone: "+1 (555) 987-6543 - ext. 101",

    },
  ];

  // -------------------- FILTERED DATA --------------------
  const filteredClients = useMemo(() => {
    return clients.filter(client => {
      const matchesSearch =
        !globalFilter ||
            client.buisnessName.toLowerCase().includes(globalFilter.toLowerCase()) ||
        client.address.toLowerCase().includes(globalFilter.toLowerCase()) ||
        client.contactName.toLowerCase().includes(globalFilter.toLowerCase());

      const matchesType = !clientType || client.clientType === clientType;
      const matchesPlan = !planType || client.planType === planType;

      const matchesDate =
        !startDate || new Date(client.startDate) >= new Date(startDate);

      return matchesSearch && matchesType && matchesPlan && matchesDate;
    });
  }, [clients, globalFilter, clientType, planType, startDate]);

  // -------------------- ACTION --------------------
  const viewDetails = row => {
    console.log("View Client Details:", row);
    // navigate(`/clients/${row.id}`) OR open modal
  };

  // -------------------- UI --------------------
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs
            title={props.t("Clients")}
            breadcrumbItem={props.t("Contact Info")}
          />
         <ClientMenu />   
          <Card>
            <CardBody>
              {/* FILTER BAR */}
              <div className="d-flex flex-wrap gap-3 mb-4">
                <InputText
                  placeholder="Search..."
                  value={globalFilter}
                  onChange={e => setGlobalFilter(e.target.value)}
                />

             
              </div>

              {/* DATA TABLE */}
              <DataTable
                value={filteredClients}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                responsiveLayout="scroll"
                emptyMessage="No clients found"
              >
                <Column field="buisnessName" header="Business Name" sortable />
                <Column field="address" header="Address" sortable />
                <Column field="contactName" header="Contact Name" />
                <Column
                  field="mobilePhone"
                  header="Mobile Phone"
                />
                <Column
                  field="phone"
                  header="Phone"
                />
              </DataTable>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

ClientsDetail.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ClientsDetail);